import { type BreadcrumbsType } from '../index';

interface Args {
  items: BreadcrumbsType['items'];
}

export default function formatStructuredData({ items }: Args) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(({ label, href }, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@id': href,
        name: label,
      },
    })),
  };
  return jsonLd;
}
